<ul cdkDropList class="list-group" *ngIf="items" (cdkDropListDropped)="drop($event)" #listGroup>
  <li cdkDrag class="list-group-item" *ngFor="let item of getItems(); let index = index" [cdkDragPreviewContainer]="listGroup">
    <div class="row">
      <div class="col-auto">
        <jhi-bary-icon icon="grip-lines" [faDirective]="FAS" class="color-light-gray pr-1 hover-bg-black"></jhi-bary-icon>
        <span class="p-1 circle" *ngIf="showPosition">{{ index + 1 }}</span>
      </div>
      <div class="col">
        {{ getItemLabel(item) }}
      </div>
    </div>
  </li>
</ul>
